import { ProjectVariable } from "../../ProjectLocationsV2/types/Location";

export type ContactType =
  | "primary_customer_contact"
  | "customer_contact"
  | "primary_internal_contact"
  | "internal_contact";

export const CONTACT_TYPE_LABELS: Record<ContactType, string> = {
  primary_customer_contact: "Primary Customer Contact",
  customer_contact: "Customer Contact",
  primary_internal_contact: "Primary Internal Contact",
  internal_contact: "Internal Contact",
};

export interface Contact {
  id: string;
  name: string;
  title: string;
  email: string;
  phone: string;
  contactType: ContactType;
  projectVariables: ProjectVariable[];
}

export type { ProjectVariable };
